module.exports = __webpack_public_path__ + "static/media/logo.741ca368.svg";